import React from 'react'
import { connect } from 'react-redux'
import { getAcabado } from '../../modules/reducer'

import Tree from './Tree'
import Frame from './Frame'

const Acabado = ({
  id,
  title,
  gaTitle,
  opciones,
  opcionesSeleccionadas,
  padding
  //index
}) => {
  //open={index === 0}
  return (
    <Tree name={title} padding={padding} open={false}>
      {opciones.map(idOpcion => (
        <Frame
          key={idOpcion}
          id={idOpcion}
          idAcabado={id}
          acabadoGaTitle={gaTitle}
          padding={padding}
          visible={opcionesSeleccionadas.indexOf(idOpcion) !== -1}
        />
      ))}
    </Tree>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  const getA = getAcabado(ownProps.id)

  return ({ reducer }, ownProps) => {
    const acabado = getA(reducer)

    return {
      title: acabado.title,
      gaTitle: acabado.gaTitle,
      opciones: acabado.opciones,
      opcionesSeleccionadas: acabado.opcionesSeleccionadas
    }
  }
}

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Acabado)
